/* PIA — Sepet Yasal Onay Kutusu (Invalute)
   Tek checkbox, koşulsuz. Onay verilmeden checkout ve hızlı ödeme butonları kapalı.
   Onay /cart/update.js ile anında cart attribute olarak yazılır. */
(function () {
  'use strict';

  /* Snippet iki kez render edilirse script de iki kez yüklenir — tek sefer çalış */
  if (window.__piaCartConsentLoaded) return;
  window.__piaCartConsentLoaded = true;

  function updateUrl() {
    var base = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
    return base + '/update.js';
  }

  function post(attrs) {
    return fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function keyOf(box) {
    return (box.getAttribute('name') || '').replace(/^attributes\[/, '').replace(/\]$/, '');
  }

  function scopes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-pia-consent]'));
  }

  function allChecked(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-pia-consent-box]'))
      .filter(function (b) { return !b.disabled; })
      .every(function (b) { return b.checked; });
  }

  function sync(scope) {
    var ok = allChecked(scope);

    var err = scope.querySelector('[data-pia-consent-error]');
    if (err && ok) err.hidden = true;

    var form = scope.closest('form');
    if (form) {
      Array.prototype.forEach.call(form.querySelectorAll('.additional-checkout-buttons'), function (w) {
        w.classList.toggle('pia-consent-blocked', !ok);
      });
    }
  }

  function syncAll() { scopes().forEach(sync); }

  function showError(scope) {
    var err = scope.querySelector('[data-pia-consent-error]');
    if (!err) return;
    err.hidden = false;
    if (err.scrollIntoView) err.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  /* Onay değişimi: attribute'u anında yaz, diğer sepet görünümünü eşitle */
  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest && e.target.closest('[data-pia-consent-box]');
    if (!box) return;

    var scope = box.closest('[data-pia-consent]');
    if (!scope) return;

    var payload = {};
    Array.prototype.forEach.call(scope.querySelectorAll('[data-pia-consent-box]'), function (b) {
      payload[keyOf(b)] = (!b.disabled && b.checked) ? 'Onaylandı' : '';
    });
    post(payload);

    scopes().forEach(function (other) {
      if (other === scope) return;
      Array.prototype.forEach.call(other.querySelectorAll('[data-pia-consent-box]'), function (b) {
        var k = keyOf(b);
        if (payload.hasOwnProperty(k)) b.checked = payload[k] === 'Onaylandı';
      });
      sync(other);
    });

    sync(scope);
  });

  /* Checkout submit engeli */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var scope = form.querySelector('[data-pia-consent]');
    if (!scope) return;
    if (allChecked(scope)) return;
    e.preventDefault();
    e.stopPropagation();
    showError(scope);
  }, true);

  /* Shop Pay / Google Pay gibi hızlı ödeme butonları engeli */
  document.addEventListener('click', function (e) {
    var wrap = e.target && e.target.closest && e.target.closest('.additional-checkout-buttons');
    if (!wrap || !wrap.classList.contains('pia-consent-blocked')) return;
    e.preventDefault();
    e.stopPropagation();
    var form = wrap.closest('form');
    var scope = form && form.querySelector('[data-pia-consent]');
    if (scope) showError(scope);
  }, true);

  function boot() {
    syncAll();
    document.addEventListener('cart:updated', syncAll);
    document.addEventListener('cart:build', syncAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
